import {Badge} from "react-bootstrap";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {handelOpenModalShoppingCard} from "../../../../../../redux/actions/modals/modalShoppingCard";
// import {handelOpenModalLoginAndRegister} from "../../../../../../redux/actions/modals/modalLoginAndRegister";
import {handelOpenMenuLeft} from "../../../../../../redux/actions";
import {useHistory} from "react-router-dom";
import {toast} from "react-toastify";
import {FaBars, FaShoppingCart} from "react-icons/all";

const HeaderPageListStores = (props) => {
    
    const dispatch = useDispatch();
    // const {token} = useSelector(state => state.user);
    const {carts, storeSelected} = useSelector(state => state.shoppingCart);
    const store = useSelector(state => state.stores.list_stores.find(storeItem => (storeSelected && storeItem.id === storeSelected.id)));
    let history = useHistory();

    const openModalShoppingCard = () => {
        // if (token) {
        //     if (store && carts.length > 0) {
        //         history.push(`/stores/${store.id}`);
        //         dispatch(handelOpenModalShoppingCard());
        //     } else {
        //         toast.warning(`سبد خرید شما خالی میباشد. لطفا ابتدا یک فروشگاه انتخاب کنید.`
        //             , {position: toast.POSITION.BOTTOM_CENTER});
        //     }
        // } else {
        //     dispatch(handelOpenModalLoginAndRegister());
        // }
        if (store && carts.length > 0) {
            history.push(`/stores/${store.id}`);
            dispatch(handelOpenModalShoppingCard());
        } else {
            toast.warning(`سبد خرید شما خالی میباشد. لطفا ابتدا یک فروشگاه انتخاب کنید.`
                , {position: toast.POSITION.BOTTOM_CENTER});
        }
    };

    const handelOpenMenu = () => {
        dispatch(handelOpenMenuLeft());
    };

    return (
        <div className='p-3 bg-white'>
            <div className='stores-header d-flex justify-content-between'>
                <div style={{flex: 1}} className='d-flex align-content-center'>
                    {(carts && carts.length > 0) &&
                    <Badge pill variant="danger" id={'badge-numbers-basket-shopping-header'} className={'ml-2'}
                           onClick={openModalShoppingCard}>
                        {carts.length}
                    </Badge>
                    }
                    <FaShoppingCart className={'base-icons-header-fixed text-success ml-2'}
                                     onClick={openModalShoppingCard}/>
                </div>
                <div>
                    <img src={'https://fruitmruit.com/icons/fm_logo_ofoghi_new.png'} alt="LOGO"
                         style={{maxWidth: 200, width: '100%'}}/>
                </div>
                <div style={{flex: 1}} className='d-flex justify-content-end align-content-center'>
                    <div className={'text-right base-box-icons-header-fixed base-box-left-icons-header-fixed'}>
                        <FaBars className='base-icons-header-fixed text-success'
                                         onClick={handelOpenMenu}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderPageListStores;
